import axios from 'axios';
import config from '../config/config';

const API_BASE = `${config.API_BASE}/api/pagamento`;

export const criarPreferencia = (valor) => axios.post(`${API_BASE}/criar-preferencia`, valor);
